import Hero from "../../components/Hero";
import CalculatorsImag1 from "../../../assets/images/Calculator1.jpg";
import MortgageOverpaymentCalculator from "../../calculators/OverpaymentCalculator";

const MortgageOverpaymentCalculatorsPage = () => {
  return (
    <div>
      <Hero
        title="Overpayment"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      <MortgageOverpaymentCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default MortgageOverpaymentCalculatorsPage;
